import React from 'react';
import { Link } from 'gatsby';

import CallToAction from '../components/CallToAction';
import Footer from '../components/Footer';
import Head from '../components/Head';
import Header from '../components/header/Header';
import Page from '../components/Page';
import ServiceHighlights from '../components/ServiceHighlights';
import SkillHighlights from '../components/SkillHighlights';
import Testimonials from '../components/Testimonials';
import Title from '../components/Title';
import { AirtableDataProvider } from '../core/AirtableDataProvider';
import { GatsbyPageProps } from '../core/types';

export default class HomeTemplate extends React.Component<GatsbyPageProps>
{

  render()
  {
    return (
      <AirtableDataProvider gatsbyContext={ this.props.pageContext }>
        <Head />
        <Page>
          <Header />
          <Title>
            <Link to="/contact#form"
              className="link pa3 ba mw5 black br-pill ttu bg-moon-gray b mt4 mb5">
                contact us now
            </Link>
          </Title>
          <ServiceHighlights />
          <SkillHighlights />
          <CallToAction />
          <Testimonials />
          <Footer />
        </Page>
      </AirtableDataProvider>
    );
  }
}